import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'src/styles/theme';

import Question from "src/assets/icons/question.svg";
import Comment from "src/assets/icons/comment.svg";
import ProfileBadge from 'src/components/ProfileBadge';
import Detail from 'src/assets/icons/qcast-detail.svg';
import { useBoundStore } from 'src/store';
import Analytics from './Analytics';
import { IndexedVideo } from '@/src/store/qcasts/data';

interface QcastSidebarProps {
  totalQuestions: number;
  totalAnswers: number;
  onSelectQcast: (index: number)=> void
}

interface TabProps {
  isActive: boolean;
}

const SidebarContainer = styled.div`
  width: 480px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  
  background-color: #FFFFFF;
  // border-radius: ${theme.borderRadius.large};
  border-left: 0px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 9999999999999999999;
  padding: 8px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0px 24px 32px;
  overflow-y: auto;
  flex: 1;
  height: 100vh;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 8px 0px;
  width: 100%;
  height: 185px;
`;

const TitleHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled.h2`
  font-family: ${theme.fonts.secondary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.xxl};
  color: ${theme.colors.black};
  letter-spacing: -0.01em;
  line-height: 120%;
  letter-spacing: -1%;

`;

const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StatIcon = styled.div`
  width: 13px;
  height: 13px;
  display: flex;
  justify-content: center;
  align-items: center;

  &>img{
    width: 100%;
    height: 100%;
  }
`;

const StatText = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.gray[500]};
`;

const TabsContainer = styled.div`
width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
`;

const Tab = styled.div<TabProps>`
  padding: 10px 0;
  font-family: ${theme.fonts.primary};
  font-weight: ${props => props.isActive ? theme.fontWeights.semiBold : theme.fontWeights.medium};
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.gray[700]};
  opacity: ${props => props.isActive ? 1 : 0.3};
  border-bottom: ${props => props.isActive ? `2px solid ${theme.colors.gray[700]}` : 'none'};
  cursor: pointer;
`;

const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: auto;
  overflow: auto;
`;


interface ReviewQcastProps {
  totalQstn: number;
  totalResponse: number;
  transcriptions: any;
  videos: any;
  currentIndex?: number
}
export const QcastSidebar: React.FC<ReviewQcastProps> = ({totalQstn, totalResponse, videos, transcriptions, currentIndex=0}) => {

  const { globalSettings, questions, recordedVideo } = useBoundStore();
  const [activeTab, setActiveTab] = useState<'details' | 'questions' | 'analytics' | 'qperks' | 'transcript'>('analytics');
  const [activeQuestion, setActiveQuestion] = useState<number>(1);
  const [qcasts, setQcasts] = useState<any[]>([]);
  const [wordCount, setWordCount] = useState<number>(0);
  const [clarityScope, setClarityScope] = useState<number>(0);
  

  const countTotalWords = (videoTranscription: Record<number, string>[]) => {
    return Object.values(videoTranscription)
    .filter(Boolean)
    .reduce((total, text: string) => {
      const wordsInText = text
        .trim()
        .split(/\s+/)
        .filter(Boolean).length;
      return total + wordsInText;
    }, 0);
  };



  useEffect(()=>{
    
    if(transcriptions && Object.keys(transcriptions).length > 0){
      const totalWordCount = countTotalWords(transcriptions);
      setWordCount(totalWordCount || 0);
    }
  }, [transcriptions])
  return (
    <SidebarContainer>
      <ContentContainer>
        <TitleSection>
          <TitleHeader>
            <HeaderRow>
              <Title>Qcast Detail</Title>
              <CloseButton>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Qcast Studio">
                    <path id="Icon" d="M2.08008 10.5001H13.7467M13.7467 10.5001L7.91341 4.66675M13.7467 10.5001L7.91341 16.3334" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path id="Line 1" d="M17.5 4.66675L17.5 16.3334" stroke="black" stroke-width="2" stroke-linecap="round"/>
                  </g>
                </svg>
              </CloseButton>
            </HeaderRow>
          </TitleHeader>
          <TabsContainer>
            {/* <Tab isActive={activeTab === 'details'} onClick={() => setActiveTab('details')}>
              Details
            </Tab>
            <Tab isActive={activeTab === 'questions'} onClick={() => setActiveTab('questions')}>
              Questions
            </Tab> */}
            <Tab isActive={activeTab === 'analytics'} onClick={() => setActiveTab('analytics')}>
              Analytics
            </Tab>
            <Tab isActive={activeTab === 'transcript'} onClick={() => setActiveTab('transcript')}>
              Transcript
            </Tab>
            {/* <Tab isActive={activeTab === 'qperks'} onClick={() => setActiveTab('qperks')}>
              Qperks
            </Tab> */}
          </TabsContainer>
        </TitleSection>

        {activeTab === 'details' && (
          <QuestionsContainer>
            Details
          </QuestionsContainer>
        )}

        {activeTab === 'questions' && (
          <QuestionsContainer>
            Questions
          </QuestionsContainer>
        )}

        {activeTab === 'analytics' && (
          <QuestionsContainer>
            <Analytics 
              wordCount={wordCount}
              questionsAnswered={totalResponse}
              totalQuestions={totalQstn}
              clarityScore={clarityScope}
            />
          </QuestionsContainer>
        )}

        {activeTab === 'qperks' && (
          <QuestionsContainer>
            Qperks
          </QuestionsContainer>
        )}
        {activeTab === 'transcript' && (
          <QuestionsContainer>
            <p>{transcriptions[currentIndex]}</p>
          </QuestionsContainer>
        )}
      </ContentContainer>
    </SidebarContainer>
  );
}; 